// seso stepper
if(typeof a1Stepper === 'undefined'){
    const SesoStepper = class {
        constructor(selector) {
            this.el = {};
            this.el.wrapper = selector instanceof HTMLElement
                ? selector
                : (
                    document.getElementById(selector) ||
                    document.querySelector(selector)
                );
            this.el.steps = this.el.wrapper ? this.el.wrapper.querySelectorAll('.step') 
                : [];

            this.params = {
                classShow: 'in-view'
            };

            this.initStepper();
        }

        initStepper() {
            // on load show steps in viewport
            this.showSteps();

            // react on scroll
            window.addEventListener('scroll', () => { 
                this.showSteps();
            });

            window.addEventListener('resize', () => { 
                this.showSteps(true);
            });
        }

        // optional param: resizeReset
        showSteps(resizeReset) {
            for (var i = 0; i < this.el.steps.length; i++) {
                var step = this.el.steps[i]
                var distInView = step.getBoundingClientRect().top - window.innerHeight;
                if (distInView < 0) {
                    step.classList.add(this.params.classShow);
                } else if (typeof resizeReset !== 'undefined' && resizeReset) {
                    // if resize - reset steps
                    step.classList.remove(this.params.classShow);
                }
            }
        }
    }

    if (typeof window !== 'undefined') {
        window.a1Stepper = SesoStepper;
    }

    window.addEventListener('load', () => {
        // stepper
        document.querySelectorAll('a1-fragment[name="stepper"]').forEach(function (fragment) {
            // params: selector
            window.a1Stepper = new SesoStepper(fragment.querySelector('.steps'));
        });
    });
}
